<template>
<LayoutContent class="env-realtime-layout-content">
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>
  </template>
  <template #toolbar>
    <el-select
      size="small"
      v-model="currentSiteId"
      popper-class="select-style"
      :popper-append-to-body="false"
      style="width: 180px;background: none;color: #ffffff;"
      @change="requestRealtimeData"
    >
      <el-option
        v-for="site in filterSites"
        :key="site.id"
        :label="site.name"
        :value="site.id">
      </el-option>
    </el-select>
  </template>
  <template #body>
    <section class="data-inner-wapper">
      <div class="data-wapper" v-for="(item, i) in realtimeData" :key="i" @mouseenter="stopDur" @mouseleave="runDur">
        <dv-border-box-8 :dur="dur.border">
          <div class="data-body">
            <div class="data-title">
              <dv-decoration-7 style="width: 150px;height: 25px;position: absolute;">
                <p>
                  <span :class="item.icon ? item.icon : 'fa fa-circle-o'"></span>
                  <span>{{item.name}}</span>
                </p>
              </dv-decoration-7>
              <dv-decoration-5 :dur="dur.title" :color="['rgb(29, 193, 245)', 'rgb(29, 193, 245)']" style="width: 300px;height: 40px;position: absolute;top: 10px;" />
            </div>
            <div class="data-inner">
              <div class="message-data-wapper">
                <div class="message-data-header">
                  <p>
                    <span :class="item.icon ? item.icon : 'fa fa-circle-o'"></span>
                    <span>{{item.name}}</span>
                  </p>
                </div>
                <dv-scroll-board
                  ref="scrollBoard"
                  :config="{
                    data: item.leftMsgData,
                    align: ['center'],
                    oddRowBGC: '#003B51',
                    evenRowBGC: '#0A2732'
                  }"
                />
              </div>
              <div class="chart-data-wapper">
                <dv-border-box-2 :color="['#939599', '#686B71']">
                  <env-chart
                    :data="item.data"
                    :current-site-id="currentSiteId"
                    :area-map="areaSiteIdMap[currentSiteId]"
                    :env-factor-map="envFactorMap[currentSiteId]"
                  />
                </dv-border-box-2>
              </div>
            </div>
          </div>
        </dv-border-box-8>
      </div>
    </section>
    <!-- <data-wrapper>
      <div class="select-group-wrapper">
        <div class="env-site-select-wrapper">
          <div class="env-site-select-header">
            <span>站点选择</span>
          </div>

          <div class="divider"></div>

          <div class="env-site-select-body">
            <ul class="env-site-select">
              <li
                v-for="site in filterSites"
                :key="site.id"
                :class="{
                  selected: site.id === currentSiteId
                }"
                @click="onSiteClick(site)"
              >{{site.name}}</li>
            </ul>
          </div>
        </div>
      </div>

      <section style="width: 100%;height: 100%;overflow: auto;">
        <div class="real-data-table" v-for="(item, i) in realtimeData" :key="i">
          <div class="real-data-table-body">
            <div class="message-data-wapper">
              <div>
                <div class="message-data-header">{{item.name}} {{new Date(currentTime).format('YYYY/MM/DD HH:mm')}}</div>
                <div class="message-data-body">
                  <dv-scroll-board
                    ref="scrollBoard"
                    :config="{
                      data: item.leftMsgData,
                      oddRowBGC: '#ffffff',
                      evenRowBGC: '#f5f7fa'
                    }"
                  />
                </div>
              </div>
            </div>
            <div class="chart-data-wapper">
              <dv-border-box-2 :color="['#939599', '#686B71']" backgroundColor="#FFFFFF">
                <env-chart
                  :data="item.data"
                  :current-site-id="currentSiteId"
                  :area-map="areaSiteIdMap[currentSiteId]"
                  :env-factor-map="envFactorMap[currentSiteId]"
                />
              </dv-border-box-2>
            </div>
          </div>
        </div>
      </section>
    </data-wrapper> -->
  </template>
</LayoutContent>
</template>

<script>
import BaseStore from '../../../components/BaseStore'
import {mapGetters} from 'vuex'
import LayoutContent from '../../../components/Layout/Content'
import DataWrapper from '../../../components/Data/DataWrapper'
import SelectCtrlGroup from '../../../components/SelectCtrlGroup/index'
import EnvChart from './EnvChart'

export default {
  name: 'SiteEnvRealtime',
  components: {EnvChart, SelectCtrlGroup, DataWrapper, LayoutContent},
  routeInfo: {
    label: '实时数据',
    icon: 'fa fa-users'
  },
  extends: BaseStore,
  data: () => ({
    defaultProps: {
      children: 'children',
      label: 'name'
    },
    siteIds: [],
    currentSiteId: '',
    currentTime: new Date(),
    realtimeData: Object.freeze({}),
    envCategoryList: Object.freeze([]),
    dur: {
      border: 15,
      title: 5
    }
  }),
  computed: {
    ...mapGetters({
      envFactorMap: 'EnvFactor/map',
      areaSiteIdMap: 'EnvFactor/areaMap'
    }),
    envCategoryMap () {
      return this.envCategoryList.reduce((map, envCategory) => {
        map[envCategory.id] = {
          ...envCategory,
          data: []
        }
        return map
      }, {})
    },
    filterSites () {
      let {areaSiteIdMap} = this
      return this.profileSites.filter(site => areaSiteIdMap[site.id])
    }
  },
  methods: {
    stopDur () {
      this.dur = {
        border: 60 * 60 * 24,
        title: 5
      }
    },
    runDur () {
      this.dur = {
        border: 15,
        title: 5
      }
    },
    onSiteClick (site) {
      let siteId = site.id

      if (siteId === this.currentSiteId) {
        return
      }
      this.currentSiteId = siteId
      this.requestRealtimeData()
    },
    clearRealTimer () {
      clearTimeout(this.realTimer)
    },
    getEnvFactorCategory () {
      this.$api.EnvFactor.getEnvFactorCategory().then(data => {
        this.envCategoryList = data
        this.requestRealtimeData()
      }).catch(console.error)
    },
    requestRealtimeData () {
      this.clearRealTimer()
      let {envCategoryMap, envFactorMap, currentSiteId} = this
      let newEnvCategoryMap = {...JSON.parse(JSON.stringify(envCategoryMap)), noGroup: {id: 'noGroup', name: '未知分组', data: []}}

      this.$api.EnvFactor.getRealtimeData().then(dataList => {
        if (!dataList.length) {
          this.realtimeData = Object.freeze([])
          return
        }
        let currentTime = dataList[dataList.length - 1].dataTime
        this.currentTime = currentTime
        let data = dataList.map(el => {
          return {
            ...el,
            ...(envFactorMap[el.siteId] ? envFactorMap[el.siteId][el.factorId] : {})
          }
        })

        data.forEach(el => {
          if (newEnvCategoryMap[el.categoryId]) {
            newEnvCategoryMap[el.categoryId].data.push(el)
          } else {
            newEnvCategoryMap['noGroup'].data.push(el)
          }
        })

        let temp = Object.values(newEnvCategoryMap).filter(el => el.data.length > 0)
        temp.forEach(item => {
          item.leftMsgData = item.data.filter(el => el.dataTime === currentTime && el.siteId === currentSiteId).map(el => [el.name, el.value + ' ' + el.displayUnit]).sort((x, y) => x[0].localeCompare(y[0]))
        })

        this.realtimeData = Object.freeze(temp)
      }).catch(console.error).finally(() => {
        if (!this.destoryed) {
          this.realTimer = setTimeout(() => {
            this.requestRealtimeData()
          }, 300000)
        }
      })
    }
  },
  watch: {
    filterSites: {
      immediate: true,
      handler (filterSites) {
        if (filterSites.length > 0) {
          this.siteIds.push(filterSites[0].id)
          this.currentSiteId = filterSites[0].id
          this.getEnvFactorCategory()
        }
      }
    }
  },
  created () {
  },
  beforeDestroy () {
    this.destoryed = true
    this.clearRealTimer()
  }
}
</script>

<style lang="scss" scoped>
.real-data-table {
  display: grid;
  height: 280px;
  grid-template-rows: 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .real-data-table-body {
    display: grid;
    grid-template-rows: 100%;
    grid-template-columns: 250px auto;
    grid-gap: 10px;
    padding-top: 5px;

    > .message-data-wapper {
      > div {
        width: 100%;
        height: 100%;
        margin: auto;
        border: 1px solid #EBEEF5;
        border-radius: 5px;
        display: grid;
        grid-template-rows: 1.8em auto;
        grid-gap: 5px;

        > .message-data-header {
          display: grid;
          grid-template-columns: auto max-content;
          align-items: center;
          border-radius: 5px 5px 0 0;
          padding: 0 10px;
          background: linear-gradient(90deg, #fbc15a 0, #fff);
          color: #ffffff;
          font-size: 18px;
          font-weight: 600;
        }

        > .message-data-body {
          overflow: auto;

          .dv-scroll-board {
            color: #606266;
          }
        }
      }
    }

    > .chart-data-wapper {
    }
  }
}
/deep/ .el-select-dropdown {
  background: #ecf5ff !important;
}
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  background-color: #f9f9f9;
}
.env-realtime-layout-content {
  user-select: none;
  background-color: #16233C;

  .layout-content-header {
    .layout-content-header-text {
      color: #ffffff;
    }
  }

  .layout-content-toolbar {
    .el-select {
      background: none;
      color: #ffffff;

      /deep/ .el-input >.el-input__inner {
        background: none;
        color: #ffffff;
      }
    }
  }

  .layout-content-body-inner {
    .data-inner-wapper {
      width: 100%;
      height: 100%;
      padding: 10px;
      overflow: auto;

      .data-wapper {
        width: 100%;
        height: 370px;
        margin-bottom: 10px;

        .dv-border-box-8 /deep/ .border-box-content {
          padding: 10px;

          .data-body {
            width: 100%;
            height: 100%;
            display: grid;
            grid-template-columns: 100%;
            grid-template-rows: 40px auto;
            grid-gap: 5px;

            .data-title {
              color: #FFFFFF;
              display: flex;
              justify-content: center;
              position: relative;

              .dv-decoration-7 p {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0;

                span {
                  display: inline-block;
                  margin: 0 5px;
                }
              }
            }

            .data-inner {
              width: 100%;
              height: 100%;
              display: grid;
              grid-template-columns: 250px auto;
              grid-template-rows: 100%;
              grid-gap: 10px;

              .message-data-wapper {
                display: grid;
                grid-template-columns: 100%;
                grid-template-rows: 50px auto;
                grid-gap: 2px;
                border: 1px solid #939599;

                .message-data-header {
                  p {
                    height: 100%;
                    margin: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #FFFFFF;
                    background-color: RGBA(3, 68, 126, .8);

                    span {
                      margin: 0 5px;
                    }
                  }
                }
                .dv-scroll-board {
                }
              }

              .chart-data-wapper {
                .dv-border-box-2 /deep/ .border-box-content {
                  padding: 5px;
                }
              }
            }
          }
        }
      }
    }
  }

  .data-wrapper {
    /deep/ {
      > .data-wrapper-body {
        display: grid;
        grid-template-columns: minmax(150px, max-content) auto;

        > * {
          min: {
            width: 0;
            height: 0;
          }
        }
      }
    }
  }
}

.env-site-select-wrapper {
  display: grid;
  grid-template-rows: 34px 1px auto;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .env-site-select-header {
    --select-ctrl-group-padding: 0;

    display: grid;
    grid-template-columns: auto max-content;
    grid-column-gap: 12px;
    align-items: center;
    font: {
      weight: 700;
    };
    line-height: 34px;
    padding: 0 5px 0 10px;
    border: 1px solid #EBEEF5 {
      bottom: 0;
    };
    background-color: #f9f9f9;
  }

  > .divider {
    background-color: #EBEEF5;
  }

  .env-site-select {
    font-size: 14px;
    max-height: 100%;
    margin: 0;
    padding: 5px 0;
    line-height: 1.7;
    border: 1px solid #EBEEF5 {
      top: 0;
    };
    color: #606266;
    overflow: auto;

    > li {
      display: flex;
      align-items: center;
      line-height: 2em;
      padding-left: 5px;
      cursor: pointer;

      > .el-checkbox {
        width: 100%;
        padding: 0 10px;
      }

      &:hover {
        background-color: #F5F7FA;
      }

      &.selected {
        background-color: #ecf5ff;
      }
    }
  }
}

.realtime-data-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  overflow: auto;

  > * {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/07Env/01Realtime/index.vue